import { render, staticRenderFns } from "./phoneId.vue?vue&type=template&id=1556bb18&scoped=true&"
import script from "./phoneId.vue?vue&type=script&lang=js&"
export * from "./phoneId.vue?vue&type=script&lang=js&"
import style0 from "./phoneId.vue?vue&type=style&index=0&id=1556bb18&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1556bb18",
  null
  
)

component.options.__file = "phoneId.vue"
export default component.exports